var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "nav-icon-fill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.86 17.45h-5.02c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41a1.4 1.4 0 0 1-1.39 1.39h-5.02a1.4 1.4 0 0 1-1.39-1.39v-5.02c0-.77.63-1.39 1.39-1.39h5.02c.76 0 1.39.62 1.39 1.39zM25.86 2.75h-5.02c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39V6.14c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .77-.63 1.39-1.39 1.39h-5.02c-.76 0-1.39-.62-1.39-1.39V6.14c0-.76.63-1.39 1.39-1.39h5.02c.76 0 1.39.63 1.39 1.39zM11.16 17.45H6.14c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .76-.62 1.39-1.39 1.39H6.14a1.4 1.4 0 0 1-1.39-1.39v-5.02c0-.77.63-1.39 1.39-1.39h5.02c.77 0 1.39.62 1.39 1.39zM11.16 2.75H6.14c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39V6.14c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .77-.62 1.39-1.39 1.39H6.14c-.76 0-1.39-.62-1.39-1.39V6.14c0-.76.63-1.39 1.39-1.39h5.02c.77 0 1.39.63 1.39 1.39z",
    fill: "#000000",
    strokeWidth: 0.15,
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.48fa24711f51c88931988ae396d3432d.svg";
export { ForwardRef as ReactComponent };